export default {
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://loto-jr.rj.r.appspot.com/"
      : "http://localhost:8080/",
  timeout: 300 * 1000, // 30 seconds
};
